import React from 'react';
import PropTypes from 'prop-types';
import LineTitleGray from '../atoms/titles/LineTitleGray';

const SubscriptionPrice = ({
  className, priceTotal, peoplePrice
}) => {

  return (
    <div className={`subscriptionPriceContainer ${className}`}>
      <LineTitleGray size="lg">
        旅行代金
      </LineTitleGray>
      {peoplePrice && peoplePrice.map((person, index) => (
        <div key={index} className="subscriptionPriceBlock">
          <div className="subscriptionPriceBlockTitle FlightAndOptionsContainer">
            <div className="subscriptionPriceBlockTitle kindContainer">
              <div className="subscriptionPriceBlockTitle number">{(index === 0 ? '代表者' : `同行者${index}`)}</div>
              <div className="subscriptionPriceBlockTitle kind">{person.kindName}</div>
            </div>
            <div className="subscriptionPriceBlockTitle flightAndPlan">{person.flightAndPlan}</div>       
              {person.optionName.map((name, index) => (
                <div className="subscriptionPriceBlockTitle" key={index}>{name}</div>
              ))}
          </div>
          <div className="subscriptionPriceBlockTitle price">{person.price.toLocaleString()}円</div>
        </div>
      ))}
      <div className="subscriptionPriceBlock total">
        <div className="subscriptionPriceBlockTitle">合計</div>
        <div className="totalPriceArea">
          <div>税込</div>
          <div className="totalPrice">
            {`${priceTotal.toLocaleString()}円`}
          </div>
        </div>
      </div>
    </div>
  );
};

SubscriptionPrice.defaultProps = {
  className: '',
  priceTotal: 0,
  ADPrice: 0,
  SNPrice: 0,
  OTPrice: 0,
  ZPPrice: 0,
  MDPrice: 0,
  CAPrice: 0,
  CBPrice: 0,
  CCPrice: 0,
  IFPrice: 0,
  C2Price: 0,
  planOptions: [],
  peoplePrice: [],
  isAna2: false,
};

SubscriptionPrice.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  priceTotal: PropTypes.number,
  ADPrice: PropTypes.number,
  SNPrice: PropTypes.number,
  OTPrice: PropTypes.number,
  ZPPrice: PropTypes.number,
  MDPrice: PropTypes.number,
  CAPrice: PropTypes.number,
  CBPrice: PropTypes.number,
  CCPrice: PropTypes.number,
  IFPrice: PropTypes.number,
  C2Price: PropTypes.number,
  people: PropTypes.object,
  peoplePrice: PropTypes.array,
  planOptions: PropTypes.array,
  isAna2: PropTypes.bool,
};

export default SubscriptionPrice;
